import React from "react"
import "../../styles/components/layout.scss"

/** View */
import Head from "../Head/Head"
import Header from "../Header"

export interface ILayout {
  children: any
}

export default ({ children }: ILayout) => {
  return (
    <>
      <Head />
      <Header />
      {children}
    </>
  )
}
